import commonBasicPlanCheckout from "./commonBasicPlanCheckout"

// Frontloaded variant has a specific offers configuration.
// The set of offers is a mix of trial and non-trial ones.
// At the same time, trial pricing here is used in an inverted way,
// meaning that trial price is higher than regular.

export default ({
  planSelectionPath,
  paymentsPath,
  isTrackVisitCheckout,
  isAbandonedBasket,
} = {}) => ({
    ...commonBasicPlanCheckout({
      planSelectionPath,
      paymentsPath,
      isTrackVisitCheckout,
      isAbandonedBasket,
    }),

    isBestDeal(offer) {
      // Regular offer is not a best deal
      if (!this.store.pricing.isOfferTrial) return false

      return this.store.pricing.isBestDeal({
        offer,
        offers: this.offers,
        isChance: this.store.values.exitIntent,
        isWithoutTrial: true,
      })
    },
  
    isMaxPriceDeal(offer) {
      // Regular offer is not a best deal
      if (!this.store.pricing.isOfferTrial) return true

      return this.store.pricing.isMaxPriceDeal({
        offer,
        offers: this.offers,
        isChance: this.store.values.exitIntent,
        isWithoutTrial: true,
      })
    },

    getPricePerPeriod(offer) {
      return this.store.pricing.getPricePerPeriod({
        offer,
        isChance: this.store.values.exitIntent,
        isWithoutTrial: true
      })
    },

    renderPricePerPeriod(offer) {
      const price = this.store.pricing.getPricePerPeriod({
        offer,
        isChance: this.store.values.exitIntent,
        isWithoutTrial: true
      })

      const period = offer?.customData?.period
      return `${price}${period || ""}`
    },

    getPriceDiscount(offer) {
      return this.store.pricing.getPriceDiscount({
        offer,
        isChance: this.store.values.exitIntent,
        isWithoutTrial: true
      })
    },

    getBestDealOffer() {
      return this.offers.find((o) => this.isBestDeal(o))
    },
  })
